import React from 'react'

export default (isArticle = false) => (
  <div className={`official_tag ${isArticle ? 'official_article' : ''}`}>
    official
  </div>
)
